import { useTeam } from 'app/frontend/base/config/context/team'
import ApiKeyField from 'app/frontend/base/components/form-fields/ApiKeyField'
import DiscordBotInstructions from './DiscordBotInstructions'

interface Props {
  open: boolean
  setOpen: (open: boolean) => void
}

const DiscordBotInstructionModal = ({ open, setOpen }: Props) => {
  const { team } = useTeam()

  return (
    <DiscordBotInstructions
      open={open}
      setOpen={setOpen}
      apiKeyField={<ApiKeyField name='privateKey' disabled />}
      notificationSettingsTo={`${team?.path}/settings#notifications`}
    />
  )
}

export default DiscordBotInstructionModal
